import React from 'react'
import styled from 'styled-components'

    const Popprogress = ({done, bel}) => {
        const [style, setStyle] = React.useState({});
        
        setTimeout(() => {
            const newStyle = {
                opacity: 1,
                width: `${done}%`
            }
            
            setStyle(newStyle);
        }, 200);
        
        return (
            <Div className="pro-side"> 
           
                <div className="progress-done" style={style}>
               <div className="prog-name"> <h6 className='bel'> {bel}</h6>
                <h6 className='percentage'>{done}%</h6></div>
                </div>
               
            </Div>
        )
    }
    
  export default Popprogress;

const Div = styled.div `
display: flex;
background-color: transparent !important;
.progress-done{
  
    position: relative;
}
.prog-name{
    display: flex;
    width: 100px;
    position: absolute;
    left: 15px;
    top: .2px;
    .bel{
padding: 0px 10px;
}
h6{
    font-size: 13px;
    margin-top: 3px;
}
}

`;